var $a9b84efe9481b18f$exports = {};
$a9b84efe9481b18f$exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `La fecha seleccionada no est\xe1 disponible`,
            other: `Las fechas seleccionadas no est\xe1n disponibles`
        })}.`
};


export {$a9b84efe9481b18f$exports as default};
//# sourceMappingURL=es-ES.mjs.map
